/* Kylea - card prodotto, carosello categorie, filtri collezione */
(function () {
  'use strict';
  if (window.__kyCardsLoaded) return;
  window.__kyCardsLoaded = true;

  var STEP = 24; // 16px pallino + 8px spazio
  var MAX = 5;

  function fitSwatches(list) {
    var items = list.querySelectorAll('[data-ky-sw]');
    var more = list.querySelector('[data-ky-more]');
    if (!items.length || !more) return;
    for (var i = 0; i < items.length; i++) items[i].hidden = false;
    more.hidden = true;
    var width = list.clientWidth;
    var cap = width ? Math.min(MAX, Math.floor((width + 8) / STEP)) : MAX;
    if (items.length <= cap) return;
    cap = Math.max(1, cap - 1);
    for (var j = 0; j < items.length; j++) items[j].hidden = j >= cap;
    more.textContent = '+' + (items.length - cap);
    more.hidden = false;
  }

  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { fitSwatches(e.target); });
  }) : null;

  function init(scope) {
    (scope || document).querySelectorAll('[data-ky-swatches]').forEach(function (list) {
      if (list.__kyFit) return;
      list.__kyFit = true;
      fitSwatches(list);
      if (ro) ro.observe(list);
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-ky-sw]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-ky-card]');
      var img = card && card.querySelector('[data-ky-card-img]');
      if (img && sw.dataset.src) {
        img.src = sw.dataset.src;
        if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
      }
      card.querySelectorAll('[data-ky-sw]').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      return;
    }
    var grid = e.target.closest('[data-ky-grid-toggle]');
    if (grid) {
      var wrap = grid.closest('[data-ky-collection]');
      if (!wrap) return;
      var mode = grid.dataset.kyGridToggle;
      wrap.setAttribute('data-grid', mode);
      wrap.querySelectorAll('[data-ky-grid-toggle]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.kyGridToggle === mode); });
      try { localStorage.setItem('kyGrid', mode); } catch (err) {}
      wrap.querySelectorAll('[data-ky-swatches]').forEach(fitSwatches);
      return;
    }
    var sortBtn = e.target.closest('[data-ky-sort]');
    if (sortBtn) {
      var f = sortBtn.closest('form');
      var inp = f && f.querySelector('[data-ky-sort-input]');
      if (inp) { inp.value = sortBtn.dataset.kySort; f.submit(); }
      return;
    }
    var openF = e.target.closest('[data-ky-filters-open]');
    if (openF) {
      var c = openF.closest('[data-ky-collection]');
      if (c) { c.classList.add('ky-filters-open'); document.documentElement.classList.add('ky-lock'); }
      return;
    }
    var closeF = e.target.closest('[data-ky-filters-close]');
    if (closeF) {
      var c2 = closeF.closest('[data-ky-collection]');
      if (c2) { c2.classList.remove('ky-filters-open'); document.documentElement.classList.remove('ky-lock'); }
      return;
    }
    // chiude i menu a tendina dei filtri cliccando fuori
    document.querySelectorAll('.ky-facet[open], .ky-sort[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-ky-filters]');
    if (!form || e.target.type === 'number') return;
    if (window.matchMedia('(max-width: 749px)').matches) return; // su mobile si applica con il bottone
    form.submit();
  });

  function restoreGrid() {
    var mode = null;
    try { mode = localStorage.getItem('kyGrid'); } catch (err) {}
    if (!mode) return;
    document.querySelectorAll('[data-ky-collection]').forEach(function (wrap) {
      wrap.setAttribute('data-grid', mode);
      wrap.querySelectorAll('[data-ky-grid-toggle]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.kyGridToggle === mode); });
    });
  }

  function boot() { restoreGrid(); init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('load', function () { document.querySelectorAll('[data-ky-swatches]').forEach(fitSwatches); });
})();